var React = require('react');

function IconHamburgerInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 2.83333C24.8115 2.83333 31.1667 9.1885 31.1667 17C31.1667 24.8115 24.8115 31.1667 17 31.1667C9.1885 31.1667 2.83333 24.8115 2.83333 17C2.83333 9.1885 9.1885 2.83333 17 2.83333ZM17 0C7.61175 0 0 7.61175 0 17C0 26.3882 7.61175 34 17 34C26.3882 34 34 26.3882 34 17C34 7.61175 26.3882 0 17 0ZM25.5 24.0833H8.5V21.25H25.5V24.0833ZM25.5 18.4167H8.5V15.5833H25.5V18.4167ZM25.5 12.75H8.5V9.91667H25.5V12.75Z","fill":"white"}));
}

IconHamburgerInline.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = IconHamburgerInline;

IconHamburgerInline.default = IconHamburgerInline;
